import React, { useState } from 'react'
import { Button, Modal, DatePicker } from 'antd'
import { FileExcelOutlined } from '@ant-design/icons'
import { downloadFile } from '../../resources'

export default function ExportEmtEscalas() {

    const [start_date, setStartDate] = useState(null)
    const [end_date, setEndDate] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [downloading, setDownloading] = useState(false)

    const showModal = () => setIsModalOpen(true)
    const handleClose = () => {
        setIsModalOpen(false)
        setStartDate(null)
        setEndDate(null)
    }

    const onExport = async () => {
        setDownloading(true)
        const endpoint = `encuestas/excel?start_date=${start_date.startOf('day').toISOString()}&end_date=${end_date.endOf('day').toISOString()}`
        await downloadFile(endpoint, 'escalas_emt.xlsx')
        setDownloading(false)
        handleClose()
    }

    return (
        <div>
            <Button icon={<FileExcelOutlined />} onClick={showModal}>
                Exportar escalas EMT
            </Button>
            <Modal title="Exportar escalas EMT" open={isModalOpen} onCancel={handleClose} destroyOnClose
                footer={[
                    <Button key="export" onClick={onExport} disabled={!(start_date && end_date)} loading={downloading} type='primary'>Exportar</Button>,
                    <Button key="close" onClick={handleClose}>Cerrar</Button>
                ]} >

                <span className='subdesc'>Seleccione rango de fechas para exportar escalas EMT en Excel</span>
                <div className='fila'>
                    <div>
                        <p className='desc'>Fecha inicial</p>
                        <DatePicker onChange={setStartDate} />
                    </div>
                    <div>
                        <p className='desc'>Fecha final</p>
                        <DatePicker onChange={setEndDate} />
                    </div>
                </div>

            </Modal>
        </div>
    )
}
